export default __webpack_public_path__ + "static/media/s3.6e632582.png";